import React, { useState } from "react";
import "../Css/Gallery.css";

import img1 from "../assets/gallery1.webp";
import img2 from "../assets/gallery2.webp";
import img3 from "../assets/gallery3.webp";
import img4 from "../assets/gallery4.jpg";
import img5 from "../assets/gallery5.webp";
import img6 from "../assets/gallery6.webp";
import img7 from "../assets/gallery7.webp";
import img8 from "../assets/gallery8.jpg";
import img9 from "../assets/gallery9.webp";

const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9];

const Gallery = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <>
      <section className="gallery-section">
        <h2 className="gallery-title">Gallery</h2>

        <div className="gallery-grid">
          {images.map((img, index) => (
            <div
              className="gallery-card"
              key={index}
              onClick={() => setSelectedImg(img)}
            >
              <img src={img} alt={`Gallery ${index + 1}`} loading="lazy" />
              <div className="overlay">View</div>
            </div>
          ))}
        </div>
      </section>

      {/* MODAL */}
      {selectedImg && (
        <div className="gallery-modal" onClick={() => setSelectedImg(null)}>
          <span className="close-btn2">&times;</span>
          <img src={selectedImg} alt="Full View" />
        </div>
      )}
    </>
  );
};

export default Gallery;
